import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import {ConfigurationProvider} from '../configuration/configuration';
import {HttpServiceProvider} from '../http-service/http-service';

/*
  Generated class for the AuthenticationProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular DI.
*/
@Injectable()
export class AuthenticationProvider {
  constructor(
    private configurationService: ConfigurationProvider,
    private httpService: HttpServiceProvider
  ) {
  }

  navigateToStartPageIfNotAuthenticated() {
    const token = this.httpService.getToken();
    if (token === null || token.length === 0) {
      window.location.href = window.location.origin;
    }
  }

  navigateToStartIfTrue(validator: () => boolean): boolean {
    const isTrue = validator();
    if (isTrue) {
      window.location.href = window.location.origin;
    }
    return isTrue;
  }

  authenticated(): boolean {
    return this.httpService.getToken() != null;
  }

  nfcLogin(tag: string): Observable<boolean> {
    return new Observable(observer => {
      this.httpService
        .post(this.configurationService.apiUrl() + "user/login/nfc", {nfcCard: tag})
        .subscribe(
          response => {
            const token = response.text();
            this.httpService.setToken(token);
            observer.next(true);
          },
          error => {
            this.httpService.clearToken();
            observer.next(false);
          }
        );
    });
  }

  login(username: string, password: string): Observable<boolean> {
    return new Observable(observer => {
      this.httpService
        .post(this.configurationService.apiUrl() + "user/login", {email: username, username: username, password: password})
        .subscribe(
          response => {
            const token = response.text();
            this.httpService.setToken(token);
            observer.next(true);
          },
          error => {
            this.httpService.clearToken();
            observer.next(false);
          }
        );
    });
  }

  logout() {
    this.httpService.clearToken();
  }

  register(username: string, password: string, token: string) {
    return this.httpService.post(this.configurationService.apiUrl() + "user/register",
      {username: username, password: password, token: token});
  }

  changePassword(currentPassword: string, newPassword: string) {
    return this.httpService.post(this.configurationService.apiUrl() + "user/password/update",
      {oldPassword: currentPassword, newPassword: newPassword});
  }

  requestNewPassword(email: string) {
    return this.httpService.post(this.configurationService.apiUrl() + "user/requestnewpassword",
      {emailAddress: email, resetUrl: this.configurationService.passwordResetUrl()});
  }
}



// WEBPACK FOOTER //
// ./src/providers/authentication/authentication.ts